/* ================= Sign-in alerts =================
   Each browser gets a random device id (kept on sign-out). After a real sign-in on a device
   the account has not seen before, the server emails the account owner. An app that was
   already signed in registers its device silently, so turning this on does not alarm anyone.
   The email's "Das war ich nicht" link opens /?secure=1 → sign out everywhere else, new password, 2FA. */
import { CLOUD, friendlyErr, loggedIn, sbUrl } from './api.js';
import { t } from '../i18n/index.js';
import { IC, closeSheet, esc, sheet, toast } from '../ui.js';

const DEV='plume.device',SEEN='plume.devseen',SECURE='plume.secure';
let fresh=false;

function deviceId(){
  try{let d=localStorage.getItem(DEV);if(!/^[a-f0-9]{32}$/.test(d||'')){d=[...crypto.getRandomValues(new Uint8Array(16))].map(b=>b.toString(16).padStart(2,'0')).join('');localStorage.setItem(DEV,d)}return d}
  catch(e){return ''}
}
export function deviceLabel(){
  const ua=navigator.userAgent||'';
  const os=/iPhone/.test(ua)?'iPhone':/iPad/.test(ua)||(/Macintosh/.test(ua)&&navigator.maxTouchPoints>1)?'iPad':/Android/.test(ua)?'Android':/Windows/.test(ua)?'Windows':/Macintosh/.test(ua)?'Mac':/Linux/.test(ua)?'Linux':'';
  const br=/Edg\//.test(ua)?'Edge':/OPR\//.test(ua)?'Opera':/Firefox\/|FxiOS/.test(ua)?'Firefox':/Chrome\/|CriOS/.test(ua)?'Chrome':/Safari\//.test(ua)?'Safari':'';
  const app=matchMedia&&matchMedia('(display-mode: standalone)').matches?' (App)':'';
  return [os,br].filter(Boolean).join(' · ')+app||'Browser';
}
/* a sign-in just happened on this device (password, code, Google, link) */
export function markFreshLogin(){fresh=true}

/* tell the server which device this is; only a fresh sign-in can trigger the email */
export async function reportDevice(){
  if(!loggedIn())return;
  const uid=CLOUD.auth.uid,dev=deviceId();if(!uid||!dev)return;
  const key=SEEN+'.'+uid;
  const wasFresh=fresh;fresh=false;
  try{if(localStorage.getItem(key)===dev&&!wasFresh)return}catch(e){}
  try{
    const r=await fetch(sbUrl('/functions/v1/notify/signin'),{method:'POST',
      headers:{apikey:CLOUD.cfg.key,Authorization:'Bearer '+CLOUD.auth.at,'Content-Type':'application/json'},
      body:JSON.stringify({device:dev,label:deviceLabel(),fresh:wasFresh,lang:document.documentElement.lang||'de'})});
    if(r.ok)try{localStorage.setItem(key,dev)}catch(e){}
  }catch(e){}
}

/* ---------- "Das war ich nicht" ---------- */
export function captureSecure(){
  try{const q=new URLSearchParams(location.search);if(q.get('secure')==='1'){sessionStorage.setItem(SECURE,'1');q.delete('secure');history.replaceState(null,'',location.pathname+(q.toString()?'?'+q:'')+location.hash)}}catch(e){}
}
export function maybeSecureSheet(){
  let want=false;try{want=sessionStorage.getItem(SECURE)==='1'}catch(e){}
  if(!want||!loggedIn())return;
  try{sessionStorage.removeItem(SECURE)}catch(e){}
  openSecureSheet();
}
export async function openSecureSheet(){
  const {verifiedFactors,sendRecovery}=await import('./auth.js');
  const has2fa=verifiedFactors().length>0;
  const b=sheet(`<div class="sheethead"><h2>${t('sec.title')}</h2><button class="iconbtn" data-a="x" aria-label="${esc(t('c.close'))}">${IC.x}</button></div>
  <div class="sheetbody"><p class="muted mb">${t('sec.lead')}</p>
    <div class="secstep"><span class="secn" aria-hidden="true">1</span><div class="grow"><b>${t('sec.s1')}</b><small>${t('sec.s1d')}</small></div><button class="btn small primary" data-a="others">${t('sec.s1b')}</button></div>
    <div class="secstep"><span class="secn" aria-hidden="true">2</span><div class="grow"><b>${t('sec.s2')}</b><small>${t('sec.s2d')}</small></div><button class="btn small" data-a="pw">${t('sec.s2b')}</button></div>
    ${has2fa?'':`<div class="secstep"><span class="secn" aria-hidden="true">3</span><div class="grow"><b>${t('sec.s3')}</b><small>${t('sec.s3d')}</small></div><button class="btn small" data-a="mfa">${t('acct.mfaAdd')}</button></div>`}
  </div>
  <div class="sheetfoot"><button class="btn" data-a="done">${t('c.done')}</button></div>`);
  const q=x=>b.querySelector(x);
  q('[data-a=x]').onclick=q('[data-a=done]').onclick=()=>closeSheet(b);
  q('[data-a=others]').onclick=async e=>{
    const btn=e.currentTarget;btn.disabled=true;btn.classList.add('busy');
    try{
      const r=await fetch(sbUrl('/auth/v1/logout?scope=others'),{method:'POST',headers:{apikey:CLOUD.cfg.key,Authorization:'Bearer '+CLOUD.auth.at}});
      if(!r.ok&&r.status!==204)throw new Error('HTTP '+r.status);
      btn.classList.remove('busy');btn.textContent=t('sec.s1ok');toast(t('sec.s1ok'));
    }catch(err){btn.disabled=false;btn.classList.remove('busy');toast(friendlyErr(err.message))}
  };
  q('[data-a=pw]').onclick=async()=>{try{await sendRecovery(CLOUD.auth.email);toast(t('auth.resetSent'))}catch(err){toast(friendlyErr(err.message))}};
  if(q('[data-a=mfa]'))q('[data-a=mfa]').onclick=()=>{closeSheet(b);import('./account.js').then(m=>m.openMfaSetup())};
}
